
import masterActionTypes from '../../constants/actions/masters/masters'

function initialState () {
  return {
    secMapMasters: null
  }
}

function masterSectionChangeSuccess (state, { secMapMasters }) {
  return {
    ...state,
    secMapMasters
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case masterActionTypes.MASTER_SECTION_CHANGE_SUCCESS:
      return masterSectionChangeSuccess(state, action)
    default:
      return state
  }
}
